import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '../../../_services/api/axios';
import withErrorHandler from '../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';
import * as FormHelpers from '../../../_helpers/Form.js';
import ReactTooltip from 'react-tooltip'

import { PageTemplate, Header, Form, Button, Spacer, GreyBox ,InputRow, Text, Input, Box, BoxTitle, Flex, FlexColumn } from 'components'

class SettingsJobPresetsPage extends Component {
    defaultFormState = {
        orders : {
            state : false,
            message : false
        },
        pieces : {
            state : false,
            message : false
        },
        stitches : {
            state : false,
            message : false
        },
        colors : {
            state : false,
            message : false
        },
        color_changes : {
            state : false,
            message : false
        },
        trims : {
            state : false,
            message : false
        },
        cone_changes : {
            state : false,
            message : false
        },
        garment_handling : {
            state : false,
            message : false
        },
        hooping : {
            state : false,
            message : false
        },
        other_work : {
            state : false,
            message : false
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            form : {
    			orders: 0,
    			pieces: 0,
    			stitches: 0,
    			colors: 0,
    			color_changes: 0,
    			trims: 0,
    			cone_changes: 0,
    			garment_handling: 0,
    			hooping: 0,
    			other_work: 0
            },
            form_state : this.defaultFormState,
            message : {
                message : null,
                type : false
            }
        }
	}

   
	componentDidMount() {
		this.props.onCalculatorJobsDefaultsFetch();
	}

    componentWillUnmount = () => {
    	this.props.onCalculatorJobsDefaultsUpdateReset();
    }

    componentDidUpdate = (prevProps, prevState, snapshot) => {
    	if(prevProps.state.defaults !== this.props.state.defaults) {
	        this.defaultValueHandler();
	    }
        if(this.props.state.updated) {
            this.props.onCalculatorJobsDefaultsUpdateReset();
            this.setState(prevState => ({
                message: {
                    message: this.props.translate('settingsjobpresetspage.success.saved'),
                    type: "success"
                },
                form_state: this.defaultFormState
            }), () => {
                ReactTooltip.rebuild();
            });
        }
        else if(prevProps.state.error !== this.props.state.error) {
            if(this.props.state.error.length) {
                this.setState(prevState => ({
                    form_state: this.defaultFormState
                }), () => {
                    this.props.state.error.forEach((error, index) => {
                        if(this.state.form_state[error.source]) {
                            this.setState(prevState => ({
                                form_state : {
                                    ...prevState.form_state,
                                    [error.source] : {
                                        state : 'error',
                                        message : this.props.translate('global.error.'+error.key.toLowerCase()+'.'+error.source.toLowerCase(),null,{missingTranslationMsg: error.message})
                                    }
                                }
                            }))
                        }
                    })
                });
            }
            if(this.props.state.error.length === 1) {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('settingsjobpresetspage.error.'+this.props.state.error[0].key.toLowerCase(),null,{missingTranslationMsg: this.props.translate('settingsjobpresetspage.error.default')}),
                        type: "error"
                    }
                }));

            }
            else {
                this.setState(prevState => ({
                    message: {
                        message: this.props.translate('settingsjobpresetspage.error.default'),
                        type: "error"
                    }
                }));
            }
        }
    }

	defaultValueHandler = (event) => {
    	if(this.props.state.defaults) {
    		this.setState(prevState => ({
	    		form: {
		            ...prevState.form,
		            orders : this.props.state.defaults.orders,
		            pieces : this.props.state.defaults.pieces,
		            stitches : this.props.state.defaults.stitches,
		            colors : this.props.state.defaults.colors,
		            color_changes : this.props.state.defaults.color_changes,
		            trims : this.props.state.defaults.trims,
		            cone_changes : this.props.state.defaults.cone_changes,
		            garment_handling : this.props.state.defaults.garment_handling,
		            hooping : this.props.state.defaults.hooping,
		            other_work : this.props.state.defaults.other_work/60
	    		}
	    	}))
		}
    }

    updateHandler = ( event ) => {
        event.preventDefault();
        if(FormHelpers.validateFields.apply(this,[['orders','pieces','stitches','colors','color_changes','trims','cone_changes','garment_handling','hooping','garment_handling']])) {
            const formData = {
                orders : this.state.form.orders,
                pieces : this.state.form.pieces,
                stitches : this.state.form.stitches,
                colors : this.state.form.colors,
                color_changes : this.state.form.color_changes,
                trims : this.state.form.trims,
                cone_changes : this.state.form.cone_changes,
                garment_handling : this.state.form.garment_handling,
                hooping : this.state.form.hooping,
                other_work : Number.parseFloat(this.state.form.other_work)*60
            };
            this.props.onCalculatorJobsDefaultsUpdate(formData);
        }
        else {
            this.setState(prevState => ({
                message: {
                    message: this.props.translate('settingsjobpresetspage.error.default'),
                    type: "error"
                }
            }));
        }
    }

    inputChangedHandler = (event, inputIdentifier) => {
        let value = event.target.value;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [inputIdentifier]: value
            }
        }))
    }

    inputBlurredHandler = (event, inputIdentifier) => {
        FormHelpers.validateFields.apply(this,[[inputIdentifier]]);
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].hideTooltip();
        }
    }
    inputFocusHandler = (event, inputIdentifier) => {
        if(this.refs[inputIdentifier + "InputRow"]) {
            this.refs[inputIdentifier + "InputRow"].showTooltip();
        }
    }

  	render() {
        var showMessage;
        if(this.state.message.message) {
            showMessage = this.state.message
        }
	    return (
            <PageTemplate header={<Header/>}>
                <Form onSubmit={this.updateHandler}>
                    <GreyBox title={this.props.translate('settingsjobpresetspage.title')} msg={showMessage} cols="2">
                        <Flex break="xs">
                            <FlexColumn col="2">
                                <Flex break="m">
                                    <BoxTitle>{this.props.translate('global.form.label.job.design_information')}</BoxTitle>
                                    <Spacer height="15px" />
                                    <InputRow ref="stitchesInputRow" label={this.props.translate('global.form.label.job.stitches')} state={this.state.form_state.stitches.state ? this.state.form_state.stitches.state : null} tip={this.state.form_state.stitches.message ? this.state.form_state.stitches.message : null}>
            		                    <Input 
            		                        identifier="stitches"
                                            ref="stitches"
            		                        type="number"
                                            minValue={1}
                                            maxValue={999999}
            		                        value={this.state.form.stitches}
            		                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
            		                </InputRow>
            		                <InputRow ref="colorsInputRow" hint={this.props.translate('global.help.job.colors')} label={this.props.translate('global.form.label.job.colors')} cols="2" state={this.state.form_state.colors.state ? this.state.form_state.colors.state : null} tip={this.state.form_state.colors.message ? this.state.form_state.colors.message : null}>
            		                    <Input 
            		                        identifier="colors"
                                            ref="colors"
            		                        type="number"
                                            minValue={1}
                                            maxValue={999}
            		                        value={this.state.form.colors}
            		                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
        			                  	</InputRow>
        			                <InputRow ref="color_changesInputRow" hint={this.props.translate('global.help.job.color_changes')} label={this.props.translate('global.form.label.job.color_changes')} cols="2" state={this.state.form_state.color_changes.state ? this.state.form_state.color_changes.state : null} tip={this.state.form_state.color_changes.message ? this.state.form_state.color_changes.message : null}>
        			                    <Input 
        			                        identifier="color_changes"
                                            ref="color_changes"
        			                        type="number"
                                            minValue={1}
                                            maxValue={999}
        			                        value={this.state.form.color_changes}
        			                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
        		                  	</InputRow>
        			                <InputRow ref="trimsInputRow" hint={this.props.translate('global.help.job.trims')} label={this.props.translate('global.form.label.job.trims')} cols="2" state={this.state.form_state.trims.state ? this.state.form_state.trims.state : null} tip={this.state.form_state.trims.message ? this.state.form_state.trims.message : null}>
        			                    <Input 
        			                        identifier="trims"
                                            ref="trims"
        			                        type="number"
                                            minValue={0}
                                            maxValue={999}
        			                        value={this.state.form.trims}
        			                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
        		                  	</InputRow>
                                    <InputRow ref="cone_changesInputRow" hint={this.props.translate('global.help.job.cone_changes')} label={this.props.translate('global.form.label.job.cone_changes')}  cols="2" state={this.state.form_state.cone_changes.state ? this.state.form_state.cone_changes.state : null} tip={this.state.form_state.cone_changes.message ? this.state.form_state.cone_changes.message : null}>
            		                    <Input 
            		                        identifier="cone_changes"
                                            ref="cone_changes"
            		                        type="number"
                                            minValue={0}
                                            maxValue={99}
            		                        value={this.state.form.cone_changes}
            		                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
            		                </InputRow>
                                </Flex>
                            </FlexColumn>
                            <FlexColumn col="2">
                                <Flex break="m">
        	                        <BoxTitle>{this.props.translate('global.form.label.job.job_information')}</BoxTitle>
                                    <Spacer height="15px" />
        			                <InputRow ref="ordersInputRow" hint={this.props.translate('global.help.job.orders')} label={this.props.translate('global.form.label.job.orders')} cols="2" state={this.state.form_state.orders.state ? this.state.form_state.orders.state : null} tip={this.state.form_state.orders.message ? this.state.form_state.orders.message : null}>
        			                    <Input 
        			                        identifier="orders"
                                            ref="orders"
        			                        type="number"
                                            minValue={1}
                                            maxValue={999999}
        			                        value={this.state.form.orders}
        			                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
        		                  	</InputRow>
        			                <InputRow ref="piecesInputRow" hint={this.props.translate('global.help.job.pieces')} label={this.props.translate('global.form.label.job.pieces')} cols="2" state={this.state.form_state.pieces.state ? this.state.form_state.pieces.state : null} tip={this.state.form_state.pieces.message ? this.state.form_state.pieces.message : null}>
        			                    <Input 
        			                        identifier="pieces"
                                            ref="pieces"
                                            ref="pieces"
        			                        type="number"
                                            minValue={1}
                                            maxValue={99999}
        			                        value={this.state.form.pieces}
        			                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
        		                  	</InputRow>
                                    <InputRow ref="hoopingInputRow" hint={this.props.translate('global.help.job.hooping')} label={this.props.translate('global.form.label.job.hooping')} cols="2" unit={this.props.translate('global.units.seconds')} state={this.state.form_state.hooping.state ? this.state.form_state.hooping.state : null} tip={this.state.form_state.hooping.message ? this.state.form_state.hooping.message : null}>
                                        <Input 
                                            identifier="hooping"
                                            ref="hooping"
                                            type="number"
                                            minValue={0}
                                            maxValue={1200}
                                            value={this.state.form.hooping}
                                            changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
                                    </InputRow>
        			                <InputRow ref="garment_handlingInputRow" hint={this.props.translate('global.help.job.garment_handling')} label={this.props.translate('global.form.label.job.garment_handling')} cols="2" unit={this.props.translate('global.units.seconds')} state={this.state.form_state.garment_handling.state ? this.state.form_state.garment_handling.state : null} tip={this.state.form_state.garment_handling.message ? this.state.form_state.garment_handling.message : null}>
        			                    <Input 
        			                        identifier="garment_handling"
                                            ref="garment_handling"
        			                        type="number"
                                            minValue={0}
                                            maxValue={9999}
        			                        value={this.state.form.garment_handling}
        			                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true} />
        		                  	</InputRow>
        			                <InputRow ref="other_workInputRow" hint={this.props.translate('global.help.job.other_work')} label={this.props.translate('global.form.label.job.other_work')} unit={this.props.translate('global.units.minutes')} state={this.state.form_state.other_work.state ? this.state.form_state.other_work.state : null} tip={this.state.form_state.other_work.message ? this.state.form_state.other_work.message : null}>
        			                    <Input 
        			                        identifier="other_work"
                                            ref="other_work"
        			                        type="number"
                                            minValue={0}
                                            maxValue={9999}
        			                        value={this.state.form.other_work}
        			                        changed={this.inputChangedHandler}
                                            blurred={this.inputBlurredHandler}
                                            focused={this.inputFocusHandler}
                                            isRequired={true}
                                            step="any"
                                            validationPattern="^\d*(\.\d{0,1})?$" />
        		                  	</InputRow>
                                </Flex>
                            </FlexColumn>
                        </Flex>
		                <Flex reverse="m">
		                    <Button data-cy="cancel-edit-job-preset-btn" href="/jobs" type="button" theme="light" value={this.props.translate('settingsjobpresetspage.secondary.label')} width="320px" />
				            <Button data-cy="save-changes-edit-job-preset-btn" value={this.props.translate('settingsjobpresetspage.submit')} type="submit" width="320px" /> 
				        </Flex>                               
                    </GreyBox>
                </Form>
			</PageTemplate>
		);
  	}
}

const mapStateToProps = state => {
    return {
    	auth: state.auth,
        defaults: state.defaults,
        state: state.calculatorJobsDefaults,
        translate: getTranslate(state.locale) 
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCalculatorJobsDefaultsUpdate: (formData) => dispatch(actionCreators.calculatorJobsDefaultsUpdate(formData)),
        onCalculatorJobsDefaultsFetch: () => dispatch(actionCreators.calculatorJobsDefaultsFetch()),
        onCalculatorJobsDefaultsUpdateReset: () => dispatch(actionCreators.calculatorJobsDefaultsUpdateReset()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(SettingsJobPresetsPage, axios));


// WEBPACK FOOTER //
// ./src/components/pages/SettingsJobPresetsPage/index.js